import TextInput from './TextInput';
import * as TextInputStyles from './TextInput.styles';

export default TextInput;

export { TextInputStyles };
